import { styled } from '@mui/material/styles';

export default styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));
